import React from 'react'

import Box, { BoxProps } from 'components/Box'

export default function Center(props: React.PropsWithChildren<BoxProps>) {
  return <Box margin="auto" {...props} />
}
